<template>
  <div class="refundsList">
    <el-table
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '0' }"
      border
      :span-method="arraySpanMethod"
      ref="orderTable"
      :data="tableData"
      style="width: 100%; overflow: visible"
    >
      <el-table-column :label="exTitle.label" min-width="489">
        <template #default="{ row }">
          <div v-if="row.isOrder" class="order">
            <div class="table-column-top-empty"></div>
            <div class="shopName">
              <img
                v-if="row.shopInfo.shopIcon && row.shopInfo.shopIcon != ''"
                :src="row.shopInfo.shopIcon"
                alt=""
                class="shop-logo"
              />
              <img v-else :src="require('@/assets/img/shop-logo.png')" class="shop-logo" />
              <span @click="linkToStore(row.shopInfo.shopId)" class="pointer">
                {{ row.shopInfo.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ row.shopInfo.merchantEntityName }}
              </span>
              <span @click.stop="onContactCustomerService(row.shopInfo.storeId)" class="pointer store__title__contact">
                <img :src="require('@/assets/img/service-icon.png')" alt="" />
                联系商家
              </span>
            </div>
            <div class="shopRight">
              <div>
                <span class="shopRight-label">退款编号：</span>
                {{ row.refundOrderSn }}
              </div>
              <div>
                <span class="shopRight-label">归属订单编号：</span>
                {{ row.orderSn }}
              </div>
              <div>
                <span class="shopRight-label">退款申请时间：</span>
                {{ row.applyTime }}
              </div>
              <div>
                <span class="shopRight-label">退款类型：</span>
                {{ renderReturnType(row.returnType) }}
              </div>
            </div>
          </div>
          <div v-else class="sku">
            <div class="skuItem" v-for="i in row.itemInfos">
              <div class="main-img">
                <img v-if="i.itemThumbnail" :src="i.itemThumbnail" alt="" />
                <img v-else :src="require('@/assets/img/goods-empty.png')" alt="" />
              </div>
              <div class="iteminfos-desc">
                <div class="title">{{ i.itemName }}</div>
                <div class="spec">{{ i.spec }}</div>
                <div class="realPrice">
                  售价：
                  <span>￥{{ i.realPriceYuan }}</span>
                </div>
                <div class="unitPrice">
                  实付单价：
                  <span>￥{{ i.unitPriceYuan }}*{{ i.number }}(购买数量)</span>
                </div>
                <div class="common-text">
                  申请退款数量：
                  <span>￥{{ i.refundNum }}</span>
                </div>
                <div class="common-text">
                  申请退款金额：
                  <span>￥{{ i.refundPayAmountYuan }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请退款总额" min-width="189">
        <template #default="{ row }">
          <div class="columnRefundSuccessAmount">
            <div class="text">￥{{ row.refundSuccessAmountYuan }}</div>
            <div class="refundShippingAmount">（含运费：￥{{ row.refundShippingAmountYuan }}）</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="退款原因" min-width="131">
        <template #default="{ row }">
          <div class="columnreFundReason">
            <div>{{ row.refundReason }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="退款方式" min-width="124">
        <template #default="{ row }">
          <div class="culumnPayType">
            <div>{{ renderPayType(row.payType) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="退款状态" min-width="131">
        <template #default="{ row }">
          <div class="columnStatus">
            <div>{{ renderStatus(row.refundShowStatus) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="address" label="操作" min-width="110">
        <template #default="{ row }">
          <div class="culumnEvent">
            <div class="link" @click="godetail(row.refundOrderSn)">查看详情</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as api from '@/services';
import { mapGetters } from 'vuex';

export default {
  props: {
    List: {
      type: Array,
      default: []
    }
  },
  computed: {
    tableData() {
      const List = [];
      this.List.map((el) => {
        List.push({
          ...el,
          isOrder: true
        });
        List.push(el);
      });
      return List;
    },
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList'
    })
  },
  data() {
    return {
      exTitle: {
        label: '商品详情'
      }
    };
  },
  methods: {
    linkToStore(shopId) {
      this.$router.push({ path: `/store/${shopId}/homePage` });
    },
    // 联系客服
    async onContactCustomerService(storeId) {
      const res = await api.shop.creatSession({
        storeId: storeId
      });
      const { groupId } = res;
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.$store.dispatch('imDialogService/openDialog');
    },

    renderReturnType(t) {
      t = parseInt(t);
      if (t === 0) {
        return '仅退款';
      }
      if (t === 1) {
        return '仅退货';
      }
      if (t === 2) {
        return '退货退款';
      }
    },
    renderPayType(t) {
      t = parseInt(t);
      if (t === 2) {
        return '对公转账';
      }
      if (t === 0) {
        return '线上退款';
      }
      if (t === 1) {
        return 'COD支付';
      }
    },
    renderStatus(code) {
      const codeList = {
        1: '待商家审核',
        2: '待买家寄回商品',
        3: '待商家确认收货',
        4: '待商家退款',
        5: '退款中',
        6: '待买家确认收款',
        7: '退款成功',
        8: '退货挂账',
        9: '退款关闭'
      };
      return codeList[code];
    },
    godetail(refundOrderSn) {
      window.open(encodeURI(location.origin + location.pathname + `#/refundDetail?refundOrderSn=${refundOrderSn}`));
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.isOrder) {
        if (column.type === 'expand') {
          return [0, 0];
        } else if (column.label === this.exTitle.label) {
          return [1, this.$refs.orderTable?.store?._data?.states?.columns?.length || 12];
        } else {
          return [0, 0];
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.refundsList {
  ::v-deep .el-table__body-wrapper {
    overflow: visible;
  }

  //::v-deep .cell {
  //  overflow-x: visible;
  //}
  ::v-deep .el-table th,
  ::v-deep .el-table td {
    vertical-align: top;
  }
  ::v-deep .el-table_1_column_1 {
    width: 487px;
    box-sizing: border-box;
    &.is-leaf {
      background-color: #fafafa;
      border-right: none;
      text-align: center;
    }
  }
  ::v-deep .el-table_1_column_2 {
    width: 188px;
    &.is-leaf {
      background-color: #fafafa;
      border-right: none;
      text-align: center;
    }
  }
  ::v-deep .el-table_1_column_3 {
    width: 133px;
    &.is-leaf {
      background-color: #fafafa;
      border-right: none;
      text-align: center;
    }
  }
  ::v-deep .el-table_1_column_4 {
    width: 121px;
    &.is-leaf {
      background-color: #fafafa;
      border-right: none;
      text-align: center;
    }
  }
  ::v-deep .el-table_1_column_5 {
    width: 128px;
    &.is-leaf {
      background-color: #fafafa;
      border-right: none;
      text-align: center;
    }
  }
  ::v-deep .el-table_1_column_6 {
    width: 128px;
    &.is-leaf {
      background-color: #fafafa;
      text-align: center;
    }
  }
  .order {
    padding: 40px 16px 16px 16px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .table-column-top-empty {
      width: 1232px;
      height: 24px;
      position: absolute;
      top: 0;
      left: -1px;
      background: #fff;
      border-bottom: 1px solid #e0e0e0;
      z-index: 10;
    }
    .shopName {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      display: flex;
      align-items: center;
      .shop-logo {
        margin-right: 4px;
        width: 24px;
        height: 24px;
      }
      .store__title__contact {
        margin-left: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #1e8dff;
        line-height: 1;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }
    }
    .shopRight {
      display: flex;
      & > div {
        font-size: 12px;
        margin-right: 12px;
        color: #333333;
      }
      .shopRight-label {
        color: #8c8c8c;
      }
    }
  }
  .sku {
    .skuItem {
      display: flex;
      padding: 16px 0;
      padding-left: 12px;
      padding-bottom: 0;
      &:nth-last-child(1) {
        padding-bottom: 16px;
      }
      .main-img {
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .iteminfos-desc {
        flex: 1;
        overflow: hidden;
        margin-left: 8px;
        .title {
          font-weight: 500;
          color: #262626;
          line-height: 20px;
          font-size: 12px;
        }
        .spec {
          font-weight: 400;
          color: #8c8c8c;
          line-height: 20px;
          font-size: 12px;
        }
        .realPrice,
        .unitPrice {
          @extend .common-text;
        }
        .common-text {
          color: #8c8c8c;
          line-height: 20px;
          font-size: 12px;
          span {
            color: #262626;
          }
        }
      }
    }
  }
  .columnRefundSuccessAmount {
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text {
      font-weight: 500;
      color: #262626;
      line-height: 12px;
      font-size: 12px;
    }
    .refundShippingAmount {
      margin-top: 8px;
      font-size: 12px;
      color: #262626;
      line-height: 12px;
    }
  }
  .columnreFundReason {
    padding: 14px 0;
    color: #262626;
    line-height: 16px;
    font-size: 12px;
    text-align: center;
  }

  .culumnPayType {
    padding: 16px 0;
    color: #262626;
    line-height: 12px;
    font-size: 12px;
    text-align: center;
  }
  .columnStatus {
    padding: 16px 0;
    color: #262626;
    line-height: 12px;
    font-size: 12px;
    text-align: center;
  }
  .culumnEvent {
    padding: 16px 0;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    .link {
      font-size: 12px;
      color: #1e8dff;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
</style>
